import { ServiceLayout } from "../components/ServiceLayout";
import { Seo } from "../components/Seo";
import { PHOTOS } from "../data/site";

export default function JunkRemoval() {
    return (
        <div data-testid="junk-removal-page">
            <Seo title="Junk Removal Adelaide | Fast & Local | Lawn Busters"
                description="Household junk, old furniture, garden waste and property clean-ups hauled away across Adelaide. 5.0-star rated local team. Free quotes — just ask." />
            <ServiceLayout
                eyebrow="Junk Removal — Adelaide"
                titleLines={["Junk Removal,", "Sorted"]}
                intro="General unwanted junk and items removed from your property — quickly and without the hassle. From a single bulky item to a full property clean-up."
                image={PHOTOS.junk}
                imageAlt="Junk and waste removal from an Adelaide property"
                preselect="Junk Removal"
                stockImage={false}
                items={[
                    { name: "Household junk", desc: "Boxes, clutter and general household items hauled away." },
                    { name: "Old furniture", desc: "Couches, tables, mattresses and other bulky furniture removed." },
                    { name: "Garden waste", desc: "Branches, clippings and green waste taken off your hands." },
                    { name: "General rubbish", desc: "Bagged or loose rubbish removed from anywhere on your property." },
                    { name: "Unwanted items", desc: "If you don't want it, chances are we can take it." },
                    { name: "Property clean-up waste", desc: "Clean-up waste from moving out, selling up or renovating." },
                    { name: "Other general junk", desc: "Not listed here? Ask us — if we can remove it, we will." },
                ]}
                note="Not sure whether something can be removed? Just ask. Call us or mention it in the booking form and we'll let you know — if we can take it, we will."
            />
        </div>
    );
}
